import SidebarLogo from '@shared/components/SidebarLogo/SidebarLogo'
import SidebarBottom from '@shared/components/SidebarBottom/SidebarBottom'
import styles from './Sidebar.module.css';

const Sidebar = ({ appVersion, children }) => {

  return (
    <div className={styles.sidebar}>
      <SidebarLogo appVersion={appVersion} />

      <div className={styles.sidebar_content}>
        <nav className={styles.sidebar_nav}>
          {children}
        </nav>
        <SidebarBottom />
      </div>
    </div>
  );
};

export default Sidebar